var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#313e48;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.218-261.34A4.877,4.877,0,0,0,12.1-263.6a4.924,4.924,0,0,0-.671.046,4.911,4.911,0,0,0-3.958-2.021,4.892,4.892,0,0,0-4.886,4.8A4.876,4.876,0,0,0,0-256.462a4.892,4.892,0,0,0,4.887,4.887H15.92a4.892,4.892,0,0,0,4.887-4.887A4.893,4.893,0,0,0,16.218-261.34Zm-.3,8.444H11.064V-258.6l2.042,2.042a.66.66,0,0,0,.934,0,.661.661,0,0,0,0-.934l-3.17-3.17a.66.66,0,0,0-.934,0l-3.17,3.17a.661.661,0,0,0,0,.934.659.659,0,0,0,.467.193.659.659,0,0,0,.467-.193L9.743-258.6v5.707H4.887a3.57,3.57,0,0,1-3.566-3.566,3.56,3.56,0,0,1,2.188-3.29.66.66,0,0,0,.4-.659c-.007-.091-.01-.184-.01-.277a3.57,3.57,0,0,1,3.566-3.566,3.584,3.584,0,0,1,3.078,1.764.66.66,0,0,0,.722.308,3.586,3.586,0,0,1,.829-.1,3.561,3.561,0,0,1,3.154,1.9.658.658,0,0,0,.6.351h.072a3.57,3.57,0,0,1,3.566,3.566A3.57,3.57,0,0,1,15.92-252.9Z",
    transform: "translate(2 270.575)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.43980134a2b2e9e273b341dc415e37b4.svg";
export { ForwardRef as ReactComponent };